export default {
  platformNotifications: (state) => state.platformNotifications,
}
